import React from 'react';
import PropTypes from 'prop-types';
import parsePolyStrings from '../logic/parsePolyStrings';

class Map extends React.Component {
  componentDidMount() {
    const map = new google.maps.Map(this.map, {
      zoom: 15,
      center: { lat: 0, lng: 0 },
    });
    const polygon = new google.maps.Polygon({
      paths: parsePolyStrings(this.props.report.area),
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      map,
    });

    const bounds = new google.maps.LatLngBounds();
    if (polygon) {
      const paths = polygon.getPath();
      if (paths && paths.length) {
        paths.forEach(path => {
          bounds.extend(path);
        });
      }

      // Fit Polygon path bounds
      map.fitBounds(bounds);
    }
  }
  render() {
    return (
      <div
        className="Map"
        ref={node => {
          this.map = node;
        }}
      />
    );
  }
}

Map.propTypes = {
  report: PropTypes.shape({
    area: PropTypes.string.isRequired,
  }).isRequired,
};

export default Map;



// WEBPACK FOOTER //
// ./src/js/components/Map.js